module.exports = __webpack_public_path__ + "img/fira-image-e.3849f67b.png";